import { Component } from "react";

import { MfaConstants } from "types/constants";

import { externalPages } from "utilities/externalPages";
import { boolToText } from "utilities/helpers";
import { isNullOrUndefined } from "utilities/object/object";

import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTExternalLink } from "commonComponents/btWrappers/BTExternalLink/BTExternalLink";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import { BTTitle } from "commonComponents/btWrappers/BTTitle/BTTitle";
import { type StatusTypes } from "commonComponents/utilities/Status/StatusDisplay";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

export interface IMultiFactorAuthStatusDisplayProps {
    isMfaEnabled?: boolean;
    className?: string;
}

interface IMfaStatusDisplayWithInfoProps extends IMultiFactorAuthStatusDisplayProps {
    renderAdditionalInfo?: () => JSX.Element | string;
}

export default class MultiFactorAuthStatusDisplay extends Component<IMfaStatusDisplayWithInfoProps> {
    render() {
        const { isMfaEnabled, renderAdditionalInfo, className } = this.props;
        return (
            !isNullOrUndefined(isMfaEnabled) && (
                <div className={className}>
                    <BTRow>
                        <BTTitle level={4}>Multi-factor Authentication Status</BTTitle>
                    </BTRow>
                    <BTRow align="middle">
                        <BTCol>
                            <StatusTagDisplay
                                statusText={boolToText(
                                    isMfaEnabled,
                                    MfaConstants.MfaRequired,
                                    MfaConstants.MfaNotRequired,
                                )}
                                statusType={boolToText(isMfaEnabled, "info", "") as StatusTypes}
                            />
                        </BTCol>
                        <BTCol className="padding-left-xs">
                            {renderAdditionalInfo && renderAdditionalInfo()}

                            <BTExternalLink
                                className="padding-left-xs"
                                isUnderline={false}
                                href={externalPages.XeroMFAServiceCloudHelpDoc}
                            >
                                Learn More
                            </BTExternalLink>
                        </BTCol>
                    </BTRow>
                </div>
            )
        );
    }
}
